import React from "react";
import { UI_BODY_SM_DF } from "oolib";
import { StyledEmpty } from "../styled";

/**
 * ─────────────────────────────────────────────────────────────────────────
 *  Dev-2 presentational seam. Empty + loading visuals for the picker.
 *  (Row-level loading skeletons are rendered by DrilldownList itself via its
 *  `isLoading` prop; this is for panel-level empty/loading messaging.)
 * ─────────────────────────────────────────────────────────────────────────
 */

export const PickerEmpty = ({ message = "No options available" }) => (
  <StyledEmpty>
    <UI_BODY_SM_DF style={{ color: "inherit", fontStyle: "inherit" }}>{message}</UI_BODY_SM_DF>
  </StyledEmpty>
);
